export function successStoriesGallery() {
    $(".success-stories-gallery").slick({
        slidesToScroll: 1,
        slidesToShow: 1,
        autoplay: true,
        infinite: true,
        arrows: false,
        fade: true,
        draggable: false,
        dots: true,
    }).on('beforeChange', function () {
        $('.success-stories-gallery .image-holder').each(function (i, el) {
            if ($(el).find('iframe').length) {
                $(el).find('iframe')[0].contentWindow.postMessage('{"event":"command", "method":"pause","func":"' + 'pauseVideo' + '","args":""}', '*');
            }
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/successStoriesGallery.js